// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7173 ? "33619ddd" : chunkId) + "." + {"4515":"fb26583fc216c8de","4765":"a75475af9c9f8fe7","7173":"31d2c14e1704d994"}[chunkId] + ".js";
};